import { FadeIn } from "../FadeIn";

const SERVICES = [
  {
    n: "01",
    title: "Firearm & Suppressor Sales",
    desc: "New and used handguns, rifles and shotguns — as well as cans and SBRs. We price everything fairly and there's even sometimes room to cut some slack. We do our best to stock quality, not quantity. Poor is a mindset.",
  },
  {
    n: "02",
    title: "Trades & Consignment",
    desc: "Bring what you have, leave with what you want. Fair trade values on the spot, and consignment listings that actually move through our marketplace network.",
  },
  {
    n: "03",
    title: "FFL & SOT Transfers",
    desc: "Buy online, save yourself money. Ask me if I can match or beat the price before you order though! If not, I don't blame anyone for saving money on a purchase. Money is too hard to come by and gets away from us too easily to overpay.",
  },
  {
    n: "04",
    title: "Appraisals & Gunsmithing",
    desc: "Know what it's worth. Estate and collection appraisals, plus trusted gunsmithing referrals for work we don't do in-house.",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="px-6 md:px-12 py-24 md:py-36">
    <FadeIn>
      <p className="text-violet-400 text-xs tracking-[0.35em] uppercase mb-4">The Manifesto</p>
      <h2 className="font-display uppercase tracking-tighter text-5xl md:text-7xl leading-[0.95] mb-16">
        What we <span className="text-outline-purple">do</span>
      </h2>
    </FadeIn>

    <div>
      {SERVICES.map((s, i) => (
        <FadeIn key={s.n} delay={i * 0.08}>
          <div data-testid={`service-${s.n}`} className="group grid md:grid-cols-12 gap-6 border-t border-white/10 py-10 md:py-14 items-start hover:bg-white/[0.02] transition-colors">
            <div className="md:col-span-2 font-display text-5xl md:text-7xl text-outline group-hover:text-primary group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
              {s.n}
            </div>
            <h3 className="md:col-span-4 font-display uppercase text-3xl md:text-4xl tracking-tight">
              {s.title}
            </h3>
            <p className="md:col-span-6 text-white/60 text-base md:text-lg leading-relaxed max-w-2xl">
              {s.desc}
            </p>
          </div>
        </FadeIn>
      ))}
    </div>
  </section>
);
